<template>
  <div class="container py-5" style="max-width: 640px">
    <div class="card text-center shadow-sm">
      <div class="card-body p-5">
        <div class="mb-4">
          <i class="fas fa-check-circle" style="font-size: 4rem; color: #28a745"></i>
        </div>
        <h3 class="mb-3">Pagamento em processamento</h3>
        <p class="text-muted mb-4">
          Recebemos sua confirmação. O Mercado Pago vai finalizar a autorização em alguns instantes.
          Assim que aprovado, o pagamento do seu plano será concluído.
        </p>
        <div v-if="state.status" class="alert alert-info mb-4">
          <small class="text-muted">Status:</small>
          <div><strong>{{ state.status }}</strong></div>
          <small v-if="state.preapprovalId">ID: {{ state.preapprovalId }}</small>
        </div>
        <router-link to="/assinatura" class="btn btn-primary">
          Ver meu plano
        </router-link>
        <router-link to="/dashboard" class="btn btn-outline-secondary ms-2">
          Ir para o painel
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'SubscriptionSuccess',
  setup() {
    const route = useRoute()
    const state = reactive({
      status: null,
      preapprovalId: null,
    })

    onMounted(() => {
      // MP passa collection_status, preapproval_id, etc. na query
      state.status = route.query.collection_status || route.query.status || null
      state.preapprovalId = route.query.preapproval_id || null
    })

    return { state }
  },
}
</script>
